<template>
  <div class="main-page-categories">
    <DefSlider :nav="screenWidth >= 992" :pagination="true" :settings="settings" :priority="true">
      <a
        v-for="({ picture, link, name }, i) in items"
        :href="link"
        class="swiper-slide category-card"
      >
        <DefImg :result="picture" :priority="i < slidesCount" />
        <span class="category-card-content">
          <span class="category-card-name">{{ name }}</span>
          <span class="category-card-link">
            {{ messages?.chose }}
            <svg class="category-card-link__icon" viewBox="0 0 20 20">
              <path
                d="M17.1885 10.7963C17.3455 10.6393 17.4337 10.4263 17.4337 10.2042C17.4337 9.98215 17.3455 9.76916 17.1885 9.6121L12.4507 4.87428C12.3734 4.79428 12.281 4.73048 12.1788 4.68659C12.0766 4.64269 11.9667 4.61959 11.8555 4.61862C11.7443 4.61766 11.634 4.63885 11.5311 4.68096C11.4282 4.72307 11.3347 4.78526 11.256 4.86389C11.1774 4.94253 11.1152 5.03604 11.0731 5.13897C11.031 5.2419 11.0098 5.35218 11.0108 5.46338C11.0117 5.57459 11.0348 5.68449 11.0787 5.78667C11.1226 5.88885 11.1864 5.98126 11.2664 6.05852L14.5746 9.36671H3.48339C3.26127 9.36671 3.04824 9.45495 2.89118 9.61201C2.73411 9.76908 2.64587 9.9821 2.64587 10.2042C2.64587 10.4263 2.73411 10.6394 2.89118 10.7964C3.04824 10.9535 3.26127 11.0417 3.48339 11.0417H14.5746L11.2664 14.3499C11.1139 14.5079 11.0294 14.7194 11.0314 14.939C11.0333 15.1586 11.1213 15.3687 11.2766 15.524C11.4319 15.6793 11.642 15.7673 11.8616 15.7692C12.0812 15.7712 12.2927 15.6867 12.4507 15.5342L17.1885 10.7963Z"
              />
            </svg>
          </span>
        </span>
      </a>
    </DefSlider>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import useScreenWidth from '@use/useScreenWidth';
import { Breakpoints } from '@/settings/device';

interface IResult {
  messages: { chose: string };
  items: [
    {
      id: number;
      name: string;
      detailPage: string;
      article: number;
      picture: {
        src: string;
        alt: string;
        width: number;
        height: number;
        isPicturePlug: boolean;
      };
      link: string;
    }
  ];
}

const props = defineProps<{ result: IResult }>();
const items = computed(() => props.result?.items);
const messages = computed(() => props.result?.messages);
const screenWidth = useScreenWidth();

const slidesCount = computed<number>(() => {
  if (screenWidth.value >= Breakpoints.tablet) {
    return 3;
  }
  return 2;
});

const settings = {
  slidesPerView: 1.2,
  // spaceBetween: 16,
  breakpoints: {
    768: {
      slidesPerView: 2.2,
      slidesPerGroup: 2,
    },
    992: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
  },
};
</script>

<style scoped lang="scss">
.main-page-categories {
  margin-bottom: 60px;
  @include point-lg {
    margin-bottom: 80px;
  }
}
.category-card {
  position: relative;
  overflow: hidden;
  :deep(.def-img) {
    transform-origin: center;
    transition: 0.2s linear transform;
  }
  &:hover {
    :deep(.def-img) {
      transform: scale(1.1);
    }
  }
}
.category-card-content {
  display: grid;
  grid-row-gap: 8px;
  justify-content: center;
  text-align: center;
  position: absolute;
  bottom: 24px;
  color: #fff;
  width: 100%;
  @include point-md {
    bottom: 32px;
    grid-row-gap: 16px;
  }
  @include point-lg {
    bottom: 40px;
  }
}
.category-card-name {
  font-size: 24px;
  font-style: italic;
  line-height: 135%;
  text-transform: uppercase;
  @include point-md {
    font-size: 28px;
  }
  @include point-lg {
    font-size: 32px;
  }
}
.category-card-link {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  gap: 4px;
  @include point-md {
    font-size: 16px;
  }
  @include point-lg {
    font-size: 18px;
  }
  &__icon {
    width: 20px;
    height: 20px;
    fill: currentColor;
  }
}
</style>
